import { translate } from './filters'

/**
 * 一般状态选项： 0 无效； 1 有效
 */
export const statusMap = {
    0: translate('bank.invalid'),
    1: translate('bank.effective'),
    createArray: (): Array<any> => {
        let keys = Object.keys(statusMap)
        let array: Array<any> = []
        keys.map((key, index) => {
            if (typeof statusMap[key] !== 'function') {
                array[index] = { key: statusMap[key], value: Number.parseInt(key) }
            }
        })
        return array
    }
}

/**
 * 银行卡状态选项： 0 未启用； 1 正常； 2 冻结
 */
export const cardStatusMap = {
    0: translate('bankCardManage.notenable'),
    1: translate('bankCardManage.normal'),
    2: translate('bankCardManage.disable'),
    createArray: (): Array<any> => {
        let keys = Object.keys(cardStatusMap)
        let array: Array<any> = []
        keys.map((key, index) => {
            if (typeof cardStatusMap[key] !== 'function') {
                array[index] = { key: cardStatusMap[key], value: Number.parseInt(key) }
            }
        })
        return array
    }
}

/**
 * 卡类型: 0-借记卡 1-信用卡 2-准贷记卡 3-预付费卡
 */
export const cardMap = {
    0: translate('bankCardManage.debitCard'),
    1: translate('bankCardManage.creditCard'),
    2: translate('bankCardManage.semiCreditCard'),
    3: translate('bankCardManage.prepaidCard'),
    createArray: (): Array<any> => {
        let keys = Object.keys(cardMap)
        let array: Array<any> = []
        keys.map((key, index) => {
            if (typeof cardMap[key] !== 'function') {
                array[index] = { key: cardMap[key], value: Number.parseInt(key) }
            }
        })
        return array
    }
}

/**
 * 是否验证： 0-未验证 1-验证通过 2-验证失败 3-验证中
 */
export const cardValidMap: any = {
    0: translate('bankCardManage.notCheck'),
    1: translate('bankCardManage.passedCheck'),
    2: translate('bankCardManage.failededCheck'),
    3: translate('bankCardManage.checking'),
    createArray: (): Array<any> => {
        let keys = Object.keys(cardValidMap)
        let array: Array<any> = []
        keys.map((key, index) => {
            if (typeof cardValidMap[key] !== 'function') {
                array[index] = { key: cardValidMap[key], value: Number.parseInt(key) }
            }
        })
        return array
    }
}

/**
 * 支付状态：
 *
 * 新增(0,"新增"),
 * 付款中(1,"付款中"),
 * 待处理(2,"待处理"),
 * 付款成功(3,"付款成功"),
 * 付款失败(4,"付款失败"),
 * 异常(5,"异常"),
 * 财务码过期(6, "财务码过期"),
 * 已取消(7, "已取消")
 */
export const payStatusMap: any = {
    4: translate('channel.loanFailure'),
    0: translate('channel.notPaying'),
    1: translate('repay.paying'),
    2: translate('statusType.processing'),
    3: translate('repay.paymentSuccess'),
    5: translate('repay.abnormal'),
    6: translate('lending.FinancialCodeExpired'),
    7: translate('lending.HasBeenCancelled'),
    createArray: (): Array<any> => {
        let keys = Object.keys(payStatusMap)
        let array: Array<any> = []
        keys.map((key, index) => {
            if (typeof payStatusMap[key] !== 'function') {
                array[index] = { key: payStatusMap[key], value: Number.parseInt(key) }
            }
        })
        return array
    }
}

/**
 * 放款类型
 */
export const oprTypeMap = {
    0: translate('channel.manualLending'),
    1: translate('channel.systemLending')
}

/**
 * 单据状态
 */
export const receiptStatusMap = {
    0: translate('repay.add'),
    1: translate('repay.reviewed'),
    2: translate('repay.doing'),
    3: translate('repay.completed'),
    4: translate('repay.refused')
}

/**
 * 是否首复贷
 */
export const businessParamMap = {
    0: translate('channel.firstLoan'),
    1: translate('channel.doubleLoan'),
    createArray: (): Array<any> => {
        let keys = Object.keys(businessParamMap)
        let array: Array<any> = []
        keys.map((key, index) => {
            if (typeof businessParamMap[key] !== 'function') {
                array[index] = { key: businessParamMap[key], value: Number.parseInt(key) }
            }
        })
        return array
    }
}

/**
 * 绑定/未绑定
 */
export const bindMap = {
    0: translate('documents.unbound'),
    1: translate('documents.bind'),
    createArray: (): Array<any> => {
        let keys = Object.keys(bindMap)
        let array: Array<any> = []
        keys.map((key, index) => {
            if (typeof bindMap[key] !== 'function') {
                array[index] = { key: bindMap[key], value: Number.parseInt(key) }
            }
        })
        return array
    }
}
